export default (items) => {
    return items.sort((item1, item2) => {
        return item1.id < item2.id ? -1 : item1.id > item2.id ? 1 : 0;
    });
}


// WEBPACK FOOTER //
// ./src/selectors/items.js